export default __webpack_public_path__ + "static/media/grok.cf332e1c.svg";